import React, { useMemo } from 'react';

import { Box, Center } from '@chakra-ui/react';
import merge from 'lodash/merge';
import { customTheme } from 'theme';

import { menuStyles } from 'components/Overlay/Menu/styles';

import { OptionsIcon } from '../../Icons';

import { IMenuProps } from './types';

import { Menu } from './index';

interface Props extends IMenuProps {}

export const TableActionsMenu = (props: Props) => {
  // Merge into a new object so the caller's styles aren't mutated, and let the
  // caller's styles override the table defaults (it was the other way round).
  const styles = useMemo(() => {
    return merge({}, menuStyles, props.styles);
  }, [props.styles]);

  return (
    <Menu
      buttonLabel={
        <Box
          border="1px solid"
          borderColor={customTheme.colors.gray['100']}
          borderRadius={7}
          color={customTheme.colors.gray['250']}
          py={1}
          boxSize={7}
        >
          <Center w="full" h="full">
            <OptionsIcon />
          </Center>
        </Box>
      }
      {...props}
      // Passed after the spread so props.styles doesn't replace the merge.
      styles={styles}
    />
  );
};
